/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Para1Inputs */

const zh_landing_audience_para1 = /** @type {(inputs: Landing_Audience_Para1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学本就辛苦，备课、批改和琐事更是消耗精力。StudyOS 就是为你卸下这些负担而生。`)
};

const en_landing_audience_para1 = /** @type {(inputs: Landing_Audience_Para1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching takes energy. Planning, marking, and admin take even more. StudyOS is built to take that weight off your shoulders.`)
};

const es_landing_audience_para1 = /** @type {(inputs: Landing_Audience_Para1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseñar consume energía. Planificar, corregir y la burocracia consumen aún más. StudyOS está hecho para quitarte ese peso de encima.`)
};

/**
* | output |
* | --- |
* | "Teaching takes energy. Planning, marking, and admin take even more. StudyOS is built to take that weight off your shoulders." |
*
* @param {Landing_Audience_Para1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_audience_para1 = /** @type {((inputs?: Landing_Audience_Para1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Para1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_para1(inputs)
	if (locale === "en") return en_landing_audience_para1(inputs)
	return es_landing_audience_para1(inputs)
});